module.exports = __webpack_public_path__ + "img/ME.837d80ce.svg";